import axios from 'axios';
import { appSettings } from '../../appSettings';

const createApiClient = (accessToken: string) => {
  const axiosInstance = axios.create({
    baseURL: appSettings.APIM_URL,
  });

  const configureApiClient = async (config: any) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    return config;
  };

  // Axios Interceptor
  axiosInstance.interceptors.request.use((config) => {
    if (accessToken) {
      return configureApiClient(config);
    } else {
      return Promise.reject(new Error('No access token found'));
    }
  });
  return axiosInstance;
};

export default createApiClient;